import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_KEYWORD_KW_SUGGESTIONS_PAGE: IInventoryPage = {
	'route': '/research/keyword/kw-suggestions',
	'title': 'KW Suggestions',
	'uiReference': [
		'Keyword discovery',
		'Suggestion sources',
		'keywords',
		'Review, copy or continue researching suggestions from each marketplace source.',
		'Export suggestions',
		'Search complete',
		'No keyword suggestions found',
		'Try a shorter phrase or another marketplace to collect more suggestions.',
		'Are Keywords Important?',
		'Simple Keyword Ranking?',
		'Why Long-Tail Keywords?',
		'What are Long-Tail Keywords',
		'Amazon Suggestions',
		'Google Suggestions',
		'What are Suggestions?',
		'How to use Suggestions?',
		'Why use Suggestions?',
		'What is Keyword Stuffing',
		'Guess Perfect Keywords',
		'Search Volume is Search Volume',
		'Best Search Volume',
		'Google vs. Amazon Keywords',
		'What are General Keywords?',
		'What are Clothing Keywords?',
		'What are Book Keywords?',
		'Keyword Variations',
		'Purpose Of Keywords',
		'Search Engine Ranking',
		'Loading Suggestions',
		'Search Keyword',
		'Marketplace',
		'Product',
		'Keyword',
		'Search',
		'Advanced Options',
		'Research guidance',
		'Show previous research tip',
		'Show next research tip',
		'Research tips',
		'Live research',
		'Here is a useful research tip while the first designs arrive.',
		'Research guide',
		'Open in KW Workbench',
		'No suggestions in this group',
		'Oh man, the board seems to be not included in the free version',
		'Copy to Clipboard',
		'Reset options',
		'Text',
		'Amazon Search Volume',
		'Google Search Volume',
		'Trends',
		'Products and Rankings',
		'Niche and Revenue',
		'Positioning',
		'Scores',
		'Filter the results for the keywords with the above filters. Please note that not all columns are shown in the below tables. They can be added through the table options (small filter icon).',
		'Search here',
		'Show 12 Months Trend',
		'Show 5 Years Trend',
		'Search on Best Sellers',
		'Search on Real Time Research',
		'Open in Amazon',
		'Open in Redbubble',
		'Open in Spreadshirt',
		'See in Google Images',
		'See in Google Shopping',
		'Required Words',
		'Required keyword matching',
		'Excluded Words',
		'Negative keyword matching',
		'min',
		'max',
		'All',
		'Any'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-suggestions/kw-suggestions-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-suggestions/kw-suggestions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-suggestions/kw-suggestions.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-suggestions/kw-suggestions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-search-input.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-search-input.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/animated-card-loader/animated-card-loader.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/animated-card-loader/animated-card-loader.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/card-carousel/card-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/card-carousel/card-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-suggestions/sub-components/kw-suggestions-list/kw-suggestions-list.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-suggestions/sub-components/kw-suggestions-list/kw-suggestions-list.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-board/kw-board.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/kw-filter-options.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/kw-filter-options.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/kw-filter-options.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-popover/kw-search-popover.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-popover/kw-search-popover.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/text-filters/text-filters.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/text-filters/text-filters.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/amazon-search-volume/amazon-search-volume.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/amazon-search-volume/amazon-search-volume.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/google-search-volume/google-search-volume.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/google-search-volume/google-search-volume.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/trends/trends.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/trends/trends.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/products-and-rankings/products-and-rankings.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/products-and-rankings/products-and-rankings.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/niche-and-revenue/niche-and-revenue.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/niche-and-revenue/niche-and-revenue.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/positioning-options/positioning-options.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/positioning-options/positioning-options.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/score-filters/score-filters.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-search-input/kw-filter-options/sub-components/score-filters/score-filters.component.html'
	],
	'aliases': []
};
